import type { ViewInputRequest } from '@/types/Ibexa'
import { IbexaContentTypeIdentifier } from '@/enums/IbexaContentTypeIdentifier'
import { i18n } from '../../translations'
import { Language } from '@/enums/Language'

type QueryInput = {
  identifier: string
  contentId?: number
  contentTypeId?: IbexaContentTypeIdentifier | IbexaContentTypeIdentifier[]
  isLocationQuery?: boolean
  limit?: string
  offset?: string
  locationId?: string
  parentLocationId?: string
  isSorted?: boolean
  languageCode?: string,
  pathString?: string,
}

export const createViewInputQuery = ({
  contentId,
  contentTypeId,
  identifier,
  isLocationQuery = true,
  limit,
  offset,
  locationId,
  parentLocationId,
  pathString,
  isSorted = false,
  languageCode = i18n.global.locale === Language.nynorsk ? Language.ibexaNyNorsk : Language.ibexaBokmal
}: QueryInput): ViewInputRequest => {
  const contentTypeQuery = !Array.isArray(contentTypeId)
    ? { AND: { ContentTypeIdentifierCriterion: [contentTypeId] } }
    : { OR: { ContentTypeIdentifierCriterion: contentTypeId } }
  return {
    ViewInput: {
      identifier: identifier,
      languageCode: languageCode,
      [isLocationQuery ? 'LocationQuery' : 'Query']: {
        Filter: {
          ...(pathString && { SubtreeCriterion: pathString }),
          ...(contentTypeId && contentTypeQuery),
          ...(locationId && { LocationIdCriterion: locationId }),
          ...(contentId && { ContentIdCriterion: contentId }),
          ...(parentLocationId && { ParentLocationIdCriterion: parentLocationId }),
          VisibilityCriterion: 0,
        },
        ...(limit && { limit: limit }),
        ...(offset && { offset: offset }),
        ...(isSorted && { SortClauses: { LocationPriority: 'ascending' } })
      }
    }
  }
}
